import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const Tabs = styled.ul`
  margin: 0;
  padding: 0;

  .tab-item {
    background-color: #f9e7cc;
    border: 1px solid transparent; 
    border-bottom: none;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    color: #ab3029;
    cursor: pointer;
    display: inline-block;
    height: 40px;
    line-height: 30px;
    list-style: none;
    min-width: 90px;
    text-align: center;
    padding: 5px;
  }
  
  .tab-item.active {
    color: #ab3029;
  }



  .tab-item + .tab-item {
    margin-left: 5px;
  }

  .tab-item.active {
    background-color: #e9a743;
    color: #ab3029;

    &.level1 {
      background-color: lighten('red', 10);
    }
  }
`;

const AdminTabs = ({ handleTabSelection, activeTab }) => {
  return (<Tabs>
    <NavLink to="/admin/projects" activeClassName="active" className="tab-item">Projects</NavLink>
    <NavLink to="/admin/stories" activeClassName="active" className="tab-item">Stories</NavLink>
    <NavLink to="/admin/tools" activeClassName="active" className="tab-item">Tools</NavLink>
  </Tabs>)
};

AdminTabs.propTypes = {
  activeTab: PropTypes.string
};

export default AdminTabs;



// WEBPACK FOOTER //
// ./src/containers/admin/AdminTabs.js